import gql from 'graphql-tag';

export default gql`
query GetPendingApps(
        $lang: String!
        ) {
    getPendingApps(
        lang: $lang
    ) {
      items {
        __typename
        uuid
        user
        lang
        data
      }
    }
}
`;
